import { Component, OnInit } from '@angular/core';
import { ComponentBase } from 'src/app/main/dynamic/component-base';

@Component({
  selector: 'app-boolean-text',
  templateUrl: './boolean-text.component.html',
  styleUrls: ['./boolean-text.component.scss']
})
export class BooleanTextComponent extends ComponentBase implements OnInit {

  valueChange: boolean = true;

  constructor() { super() }

  ngOnInit() {
    this.valueChange = this.attribute.value!=null?true:false;
  }

  onValueChange(value: boolean) {
    this.valueChange = value;
    this.attribute.value = null;
  }
}
